import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    clearSingleDropDownList,
    getDropdownValues,
    getValidateAccountDetails,
    resetSurgeryDetails,
    resetValidateAccountDetails,
} from '../../scheduleSurgery/redux/actions';

/**
 * Custom hook to handle account validation and dispatch related actions.
 * @param {Object} params
 * @param {Object} params.usageDetails - Usage details object.
 * @param {Object} params.validateAccount - Account validation object.
 * @param {Object} params.reportUsageFormObj - Report usage form object.
 * @param {Function} params.dispatch - Redux dispatch function.
 * @param {Function} params.setSelectedOutsideAccount - Redux action creator for outside account selection.
 * @param {Function} params.getDropdownValues - Redux action creator for dropdown values.
 * @param {Function} params.editUsageDetails - Redux action creator for editing usage details.
 */
export function useAccountValidationEffect({
    usageDetails,
    validateAccount,
    reportUsageFormObj,
    dispatch,
    setSelectedOutsideAccount,
    editUsageDetails,
}) {
    useEffectWithErrorLogging(() => {
        if (usageDetails?.changeAccountEnabled) {
            if (
                validateAccount?.data?.isInsideTerrAcc === false &&
                reportUsageFormObj?.accountId
            ) {
                dispatch(
                    setSelectedOutsideAccount({
                        accountId: reportUsageFormObj?.accountId || '',
                        accountName: reportUsageFormObj?.accountName || '',
                        accountFormattedName:
                            reportUsageFormObj?.accountFormattedName || '',
                    })
                );
                dispatch(getDropdownValues({ dropDownName: 'accountLookup' }));
            }
            if (
                validateAccount?.data?.isInsideTerrAcc &&
                (validateAccount?.data?.districtId !==
                    usageDetails?.districtId ||
                    validateAccount?.data?.territoryId !==
                        usageDetails?.territoryId) &&
                reportUsageFormObj?.accountId
            ) {
                dispatch(
                    editUsageDetails({
                        districtId:
                            validateAccount?.data?.districtId ||
                            usageDetails?.districtId,
                        territoryId:
                            validateAccount?.data?.territoryId ||
                            usageDetails?.territoryId,
                    })
                );
            }
            if (usageDetails?.changeAccountEnabled) {
                dispatch(
                    editUsageDetails({
                        isHCPOAccountNonTissue:
                            validateAccount?.data?.isHCPOAccountNonTissue,
                        isHCPOAccountTissue:
                            validateAccount?.data?.isHCPOAccountTissue,
                    })
                );
            }
        }
    }, [validateAccount]);
}
